import React, { useContext } from "react";
import { ButtonGroup, Input } from "../../../../controls";
import { CartContext } from "../POS";
import { DropLi } from "../../../../hooks";
import { AppContext } from "App";

const CartAdditionalFields = () => {
  const { DiscountTypes } = DropLi();
  const { setCartData, cartData } = useContext(CartContext);
  const { access } = useContext(AppContext);

  const handleInpChg = (e) => {
    setCartData((j) => ({ ...j, [e.target.name]: e.target.value }));
  };

  return (
    <div className="grid gap-[15px] ml-[25px]">
      <div className="flex gap-[2px]">
        <Input
          placeholder="Discount"
          name="discount"
          type="number"
          variant="outlined"
          size="small"
          value={cartData.discount}
          onChange={handleInpChg}
        />
        <ButtonGroup
          value={cartData.disType || 0}
          onChange={handleInpChg}
          name="disType"
          options={DiscountTypes}
        />
      </div>
      {access?.pos?.discount && (
        <Input
          placeholder="Note"
          name="note"
          value={cartData.note}
          variant="outlined"
          size="small"
          multiline
          rows={2}
          onChange={handleInpChg}
        />
      )}
    </div>
  );
};

export default CartAdditionalFields;
